import { render, staticRenderFns } from "./resume-detail-list.vue?vue&type=template&id=598fe141&scoped=true"
import script from "./resume-detail-list.vue?vue&type=script&lang=js"
export * from "./resume-detail-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598fe141",
  null
  
)

export default component.exports